export class FloatingLabelsClass {
  constructor() {
    FloatingLabelsClass.attachListeners();
  }

  static attachListeners() {
    document.addEventListener('focusin', FloatingLabelsClass.onFocusInHandler);
    document.addEventListener('input', FloatingLabelsClass.onFocusInHandler);
    document.addEventListener('focusout', FloatingLabelsClass.onFocusOutHandler);
  }

  static onFocusInHandler(event) {
    let input = event instanceof Event ? event.target : event;

    if (!input.classList.contains('floating-input')) {
      return false;
    }

    const wrapper = input.closest('.floating-wrapper');
    if (!wrapper) {
      return false;
    }

    wrapper.classList.add('is-completed');
  }

  static onFocusOutHandler(event) {
    let input = event instanceof Event ? event.target : event;

    if (!input.classList.contains('floating-input')) {
      return false;
    }

    const wrapper = input.closest('.floating-wrapper');
    if (!wrapper) {
      return false;
    }

    if (input.value === '') {
      wrapper.classList.remove('is-completed')
    }
  }
}

export default () => new FloatingLabelsClass();
